module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_KidsClub.dd9d6b86.jpg";